import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import supabase from "../../supabase";
import { useNotification } from "../../context/NotificationContext";

import ImageUploader from '../../components/ImageUploader/ImageUploader';

const AddRoom = () => {
  const { id: propertyId } = useParams();
  const [name, setName] = useState("");
  const [superficie, setSuperficie] = useState("");
  const [images, setImages] = useState([]);
  const [defaultImageIndex, setDefaultImageIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  

  // Ajouter la pièce et ses images
  const handleAddRoom = async () => {
    if (!name.trim() || !superficie.trim()) {
      showNotification("Veuillez remplir tous les champs.", "warning");
      return;
    }

    setLoading(true);

    try {
      // Étape 1 : Insérer la pièce dans la table 'rooms'
      const { data: roomData, error: roomError } = await supabase
        .from("rooms")
        .insert([
          {
            name,
            superficie: parseFloat(superficie),
            property_id: propertyId,
          },
        ])
        .select()
        .single();

      if (roomError) throw roomError;

      // Étape 2 : Ajouter les images dans la table 'images'
      const imagePromises = images.map(async (img, index) => {
        // Use img.file directly as it's already a File object (potentially converted HEIC)
        const { error } = await supabase.from("images").insert([
          {
            url: img.url, // Use the object URL for display/storage
            room_id: roomData.id,
            is_default: index === defaultImageIndex, // Définit l'image par défaut
          },
        ]);

        if (error) throw error;
      });

      await Promise.all(imagePromises);

      showNotification("Pièce et images ajoutées avec succès !", "success");
      navigate(`/property/${propertyId}`);
    } catch (error) {
      console.error(
        "Erreur lors de l’ajout de la pièce et des images :",
        error
      );
      showNotification(
        `Une erreur est survenue : ${
          error.message || "Erreur inconnue"
        }. Veuillez vérifier les détails dans la console.`, "danger"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4" style={{ color: "#ff8c00" }}>
        Ajouter une pièce
      </h2>

      {/* Champ Nom */}
      <div className="mb-3">
        <label className="form-label">Nom de la pièce</label>
        <input
          type="text"
          className="form-control"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      {/* Champ Superficie */}
      <div className="mb-3">
        <label className="form-label">Superficie (m²)</label>
        <input
          type="number"
          className="form-control"
          value={superficie}
          onChange={(e) => setSuperficie(e.target.value)}
        />
      </div>

      {/* Champ Image */}
      <div className="mb-3">
        <label className="form-label">Images</label>
        <ImageUploader
          images={images}
          setImages={setImages}
          defaultImageIndex={defaultImageIndex}
          setDefaultImageIndex={setDefaultImageIndex}
        />
      </div>

      {/* Boutons */}
      <button
        className="btn btn-primary"
        style={{ backgroundColor: "#ff8c00", border: "none" }}
        onClick={handleAddRoom}
        disabled={loading}
      >
        {loading ? "Ajout en cours..." : "Ajouter la pièce"}
      </button>
      <button className="btn btn-secondary ms-2" onClick={() => navigate(-1)}>
        Annuler
      </button>
    </div>
  );
};

export default AddRoom;
